// assets
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import AuditOutlined from '@ant-design/icons/AuditOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import FolderOpenOutlined from '@ant-design/icons/FolderOpenOutlined';

// icons
const icons = {
  BarChartOutlined,
  FileTextOutlined,
  AuditOutlined,
  UserOutlined,
  WarningOutlined,
  FolderOpenOutlined
};

// ==============================|| MENU ITEMS - REPORTS ||============================== //
// Soft-launch shells: Member Reports, Invoice Reports, Claim Reports.
// Eligibility menu removed 2026-08-05 — use Member Reports → Centre Eligibility (export there).
// Route `/reports/eligibility` kept for bookmarks; page/API not deleted yet.
// Broker report lives at `/reports/broker` (route kept). Open it from Invoice Reports, not a sidebar item.
// Sidebar + page heading: Member Reports (eligibility was an interim heading).

const reports = {
  id: 'reports',
  title: 'Reports',
  type: 'collapse',
  url: '/reports',
  icon: icons.BarChartOutlined,
  permission: {
    module: 'reports',
    level: 10
  },
  children: [
    {
      id: 'reports-members',
      title: 'Member Reports',
      type: 'item',
      url: '/reports/members',
      icon: icons.UserOutlined,
      permission: {
        module: 'reports',
        level: 10
      }
    },
    {
      id: 'reports-invoices',
      title: 'Invoice Reports',
      type: 'item',
      url: '/reports/invoices',
      icon: icons.FileTextOutlined,
      permission: {
        module: 'reports',
        level: 10
      }
    },
    {
      id: 'reports-claims',
      title: 'Claim Reports',
      type: 'item',
      url: '/reports/claims',
      icon: icons.AuditOutlined,
      permission: {
        module: 'reports',
        level: 10
      }
    },
    {
      id: 'reports-browser',
      title: 'Report Browser',
      type: 'item',
      url: '/reports/browser',
      icon: icons.FolderOpenOutlined,
      permission: {
        module: 'reports',
        level: 10
      }
    },
    {
      id: 'reports-discrepancies',
      title: 'Status discrepancies',
      type: 'item',
      url: '/reports/discrepancies',
      icon: icons.WarningOutlined,
      devOnly: true
    }
  ]
};

export default reports;
